import React, { useEffect, useState } from "react";
import { AllTabType, IqueryParams } from "src/types/GlobalInterfaces";
import DrawerTitle from "../Drawer/DrawerTitle";
import defaultProfile from "src/assets/images/default_profile_image.png";
import { Link } from "react-router-dom";
import moment from "moment";
import { resetCounter } from "src/Store/reducer";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import { IPaginated } from "src/types/paginated";
import { useDispatch } from "react-redux";
import qs from "qs";
import InfinteScrollWrapper from "../GlobalComponents/Widget/InfinteScrollWrapper";
import ManageDoctorScreen from "./ManageDoctorScreen";
import NoNotificationIcon from "src/assets/images/not-data/no-notification.png";

interface IProps {
  onBack?: () => void;
  setActiveTab?: (tab: AllTabType) => void;
  onClose?: () => void;
}

interface INotifications {
  _id: string;
  imageUrl: string;
  createdAt: string;
  title: string;
  message: string;
  routeId: string;
  notificationRoute:
    | "addTest"
    | "appoinment"
    | "chat"
    | "discussion"
    | "testAcess"
    | "healthProfile"
    | "accountVerification"
    | "diagnostic-order"
    | "pharma-order"
    | "home-care-order"
    | "my-customer"
    | "paymentandwithdraw"
    | "supportType"
    | "myProfile";
}

interface INotificationResponse {
  documents: INotifications[];
  paginated: IPaginated;
}

const NotificationScreen: React.FC<IProps> = ({
  onBack,
  setActiveTab,
  onClose,
}) => {
  const [data, setData] = useState<any[]>([
    {
      _id: "1",
      imageUrl: "https://via.placeholder.com/150",
      createdAt: "2021-01-01",
      title: "New Notification",
      message:
        "This is a new notification | This is a new notification | This is a new notification | This is a new notification | This is a new notification | This is a new notification",
      routeId: "1",
      notificationRoute: "addTest",
    },
  ]);

  const dispatch = useDispatch();
  // States for loading status, pagination, and customer data
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  }); // Handles pagination
  const [allNotifications, setAllNotifications] = useState<INotifications[]>(
    []
  );
  const [crrDoctor, setCrrDoctor] = useState<any>(null);

  const [queryParams, setQueryParams] = useState<IqueryParams>({
    page: 1,
    limit: 10,
  });

  // API_CALL to fetch notifications from the server
  const fetchNotifications = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<INotificationResponse>({
      path: `/notification-setting/notification?${qs.stringify(queryParams)}`,
    });
    if (res) {
      let { documents = [], paginated } = res;
      setAllNotifications((prev) => [...prev, ...documents]);
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  const handleNavigate = (item: INotifications): string | undefined => {
    const { notificationRoute, routeId } = item;
    switch (notificationRoute) {
      case "addTest":
        return `/test-result/${routeId}/view`;
      case "appoinment":
        return `/appointment/${routeId}/view`;
      case "chat":
        return undefined;
      case "myProfile":
        return undefined;
      case "discussion":
        return `/discussion/${routeId}/detail`;
      case "testAcess":
        return `/test-result/${routeId}/view`;
      case "healthProfile":
        return `/customer-healthprofile/${routeId}/view`;
      case "accountVerification":
        return `/account-settings`;
      case "diagnostic-order":
        return `/orders/diagnostic/${routeId}/view`;
      case "pharma-order":
        return `/orders/pharma/${routeId}/view`;
      case "home-care-order":
        return `/customer/homecare-appointment/${routeId}/view`;
      case "my-customer":
        return `/my-customers`;
      case "paymentandwithdraw":
        return `/payouts-withdrawal?tab=withdrawl`;
      case "supportType":
        return `/support-hub`;
      default:
        return "";
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, [queryParams]);

  useEffect(() => {
    (async () => {
      const { res, err } = await httpRequest<any>({
        path: "/notification-setting/read/notification",
      });
      if (res) {
        dispatch(resetCounter("unreadNotificationCount"));
      } else {
        console.log("fetchunReadCount", err);
      }
    })();
  }, []);

  return crrDoctor ? (
    <ManageDoctorScreen
      onBack={() => {
        setCrrDoctor(null);
      }}
      setActiveTab={(tab) => {
        setCrrDoctor(null);
      }}
      currentDoctor={crrDoctor}
      setCurrentDoctor={setCrrDoctor}
      defaultTab="Chat"
    />
  ) : (
    <>
      <DrawerTitle
        title="Notifications"
        backBtn
        onBack={onBack}
        id="back-button"
      />
      <div className="w-full side-bar-gap side-bar-padding-3">
        <div className="w-full h-fit get-for-top"></div>
        <InfinteScrollWrapper
          length={allNotifications.length}
          isLoading={isLoader}
          currentPage={queryParams.page}
          totalPages={paginated.totalPages}
          onLoadMore={(page) => {
            setQueryParams((prev) => ({ ...prev, page }));
          }}
          noDataOptions={{
            text: "No notifications found",
            text2: "You don't have any notifications yet.",
            buttonText: "Go Back",
            buttonOnPress: onBack,
            iconImagePath: NoNotificationIcon
          }}
          calculateHeight
          itemClassName=".get-for-top"
        >
          {allNotifications.map((item, index) => {
            return (
              <Link
                to={handleNavigate(item) || ``}
                onClick={() => {
                  if (item.notificationRoute === "chat") {
                    setCrrDoctor({
                      id: item.routeId,
                      redNotified: 0,
                    });
                  } else if (item.notificationRoute === "myProfile") {
                    onBack?.();
                    return;
                  } else {
                    onClose?.();
                  }
                }}
                key={index}
                className="w-full shadow-all-light-2 rounded-lg p-2 2xl:p-3 bg-white"
                id={`notification-card-${index}`}
              >
                <div className="flex justify-between gap-3 relative">
                  <div className="flex items-center gap-2 lg:gap-[0.3vw]">
                    <div className="">
                      <img
                        alt="User"
                        className="rounded-full w-[50px] min-w-[50px] lg:min-w-[4.7vw] aspect-[1/1] object-cover"
                        src={`${item?.imageUrl}`}
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          if (target) {
                            target.src = defaultProfile;
                          }
                        }}
                      />
                    </div>
                    <div>
                      <p className="font-size-18px font-Poppins-Medium text-[#202020]">
                        {item?.title || ""}
                      </p>
                      <p className="font-size-14px font-Poppins-Regular line-clamp-2 text-[#555555]">
                        {item?.message || ""}
                      </p>
                    </div>
                  </div>
                  <div className="absolute right-0 top-0">
                    <p className="font-size-14px text-[#737373] font-Poppins-Regular whitespace-nowrap">
                      {moment(item.createdAt).format("DD-MM-YYYY, hh:mm A")}
                    </p>
                  </div>
                </div>
              </Link>
            );
          })}
        </InfinteScrollWrapper>
      </div>
    </>
  );
};

export default NotificationScreen;
